import { Card, Grid } from '@mui/material';
import { BrandIcon, Typography } from '@uhc-tempo/components';
import { IconCost } from '@uhc-tempo/icons';
import React from 'react';
import formatNumberToCurrency from '../../../utils/NumberUtil';
import { unitMessage } from '../../../utils/EstimatePageUtil';

const GeoAverageCost = ({ geoAverageCost, carePathServiceTypes }) => {
    const costToDisplay = geoAverageCost
        ? `${formatNumberToCurrency(geoAverageCost.p25)} - ${formatNumberToCurrency(
              geoAverageCost.p75
          )}`
        : 'Not Available';
    return (
        <Card variant="outlined" style={{ borderRadius: '8px' }}>
            <Grid container alignItems="center" wrap="nowrap">
                <Grid item style={{ paddingLeft: '14px' }}>
                    <BrandIcon
                        icon={IconCost}
                        size="SMALL"
                        styleVariation="TWO_TONE_LIGHT_CIRCLE"
                    />
                </Grid>
                <Grid item style={{ paddingLeft: '14px', paddingRight: '14px' }}>
                    <Grid container alignItems="center" wrap="nowrap">
                        <Typography.Paragraph
                            style={{
                                color: '#000000',
                                marginBottom: '0px',
                                fontWeight: '500',
                                fontSize: '16px',
                            }}
                        >
                            Cost Range in Your Area:{' '}
                        </Typography.Paragraph>
                        <Typography.Paragraph
                            data-testid="areaAverageCost"
                            style={{
                                color: '#000000',
                                marginBottom: '0px',
                                fontWeight: '700',
                                fontSize: geoAverageCost ? '20.25px' : '18px',
                                paddingRight: '8px',
                                marginLeft: '8px',
                            }}
                        >
                            {costToDisplay}
                        </Typography.Paragraph>
                        <Typography.Paragraph
                            data-testid="areaAverageCostUnit"
                            style={{
                                color: '#000000',
                                marginBottom: '0px',
                                fontWeight: '500',
                                fontSize: '14px',
                            }}
                        >
                            {unitMessage(carePathServiceTypes)}
                        </Typography.Paragraph>
                    </Grid>
                </Grid>
            </Grid>
        </Card>
    );
};
export default GeoAverageCost;
